import { ReactNode } from 'react';
import { type Sx, Tabs } from '@mantine/core';

type Props = {
  children: ReactNode;
  sx?: Sx;
};

export const SidebarTabsList = ({ children, sx }: Props) => {
  return (
    <Tabs.List
      sx={theme => ({
        padding: theme.other.spacing(0, 3),
        backgroundColor: theme.white,
        flexWrap: 'nowrap',
      })}
    >
      {children}
    </Tabs.List>
  );
};
